/**
 * Created by Karol Kluska on 10.11.17.
 */

angular
  .module('app')
  .constant('ERROR_CODES', {
    UNAVAILABLE_ROOM_GROUP: 14001
  });
